<template>
  <router-link class="navigation-a-underline--remove" :to="notificationLink">
    <v-list>
      <v-list-item :disabled="notification.seen !== null">
        <v-list-item-avatar>
          <v-icon
            :color="notification.seen === null ? 'primary' : 'grey lighten-1'"
          >
            {{ notificationIcon }}
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-capitalize">{{
            titleCase(notification.notif_type)
          }}</v-list-item-title>

          <v-list-item-subtitle
            style="white-space: break-spaces"
            class="pt-2"
            >{{ notification.message }}</v-list-item-subtitle
          >
        </v-list-item-content>

        <v-list-item-action>
          <time
            class="float-right mr-3 pt-3"
            :datetime="$moment(notification.created)"
          >
            <v-list-item-subtitle>{{
              $moment(notification.created) | moment("from")
            }}</v-list-item-subtitle>
          </time>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </router-link>
</template>
<script>
export default {
  props: {
    notification: {
      type: Object,
      default: Object,
    },
  },
  data: () => ({}),
  computed: {
    notificationLink() {
      const linksLookup = [
        {
          type: "NEW_BOAT",
          route: {
            name: "boatsDetails",
            params: { id: this.notification.object_info.crm_boat_uuid || "" },
          },
        },
        {
          type: "PENDING_BOAT_REQUEST",
          route: {
            name: "boatsDetails",
            params: { id: this.notification.object_info.crm_boat_uuid || "" },
          },
        },
        {
          type: "NEW_TASK",
          route: {
            name: "tasksDetails",
            params: {
              id: this.notification.object_info.crm_internal_task_uuid || "",
            },
          },
        },
        {
          type: "TASK_STATUS_CHANGED",
          route: {
            name: "tasksDetails",
            params: {
              id: this.notification.object_info.crm_internal_task_uuid || "",
            },
          },
        },
        {
          type: "NEW_NOTE",
          route: {
            name: "messages-thread",
            params: {
              id: this.notification.object_info.crm_ticket_uuid || "",
            },
          },
        },
        {
          type: "NEW_MESSAGE",
          route: {
            name: "messages-thread",
            params: {
              id: this.notification.object_info.crm_ticket_uuid || "",
            },
          },
        },
        {
          type: "NEW_REPLY",
          route: {
            name: "messages-thread",
            params: {
              id: this.notification.object_info.crm_ticket_uuid || "",
            },
          },
        },
        {
          type: "ANNOUNCEMENT",
          route: "",
        },
      ];

      const findLink = linksLookup.find((item) => {
        return item.type === this.notification.notif_type;
      });

      if (typeof findLink === "undefined") {
        return "";
      }

      return findLink.route;
    },
    notificationIcon() {
      const typeIconLookup = [
        {
          name: "TASK",
          icon: "mdi-calendar",
        },
        {
          name: "MESSAGE",
          icon: "mdi-account-details",
        },
        {
          name: "BOAT",
          icon: "mdi-sail-boat",
        },
        {
          name: "ANNOUNCEMENT",
          icon: "mdi-information",
        },
      ];
      const typeIcon = typeIconLookup.find((item) => {
        return item.name === this.notification.object_type;
      });

      if (typeof typeIcon === "undefined") {
        return "mdi-clipboard-text";
      }

      return typeIcon.icon;
    },
  },
  methods: {
    titleCase(str) {
      return str.replaceAll("_", " ").toLowerCase();
    },
  },
};
</script>
<style>
.navigation-a-underline--remove {
  text-decoration: none;
}
</style>
